<template>
    <div v-html="require(`../../../../../public/web/images/${icon}.svg`)"></div>
</template>

<script>
  export default {
    props: ['icon']
  }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/layout/SvgIcon.vue